import React from "react";

const BookCard = ({ book, readBook }) => {
    return (
        <div
            style={{
                width: 400,
                height: 200,
                borderRadius: 16,
                boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                background: "#fff",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                margin: 16
            }}
        >
            {/* Top section: Book Name */}
            <div
                style={{
                    background: "linear-gradient(90deg, #4f8cff 0%, #6dd5ed 100%)",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: 17, // smaller font size
                    padding: "10px 24px",
                    letterSpacing: 1,
                    borderBottom: "1px solid #e0e0e0",
                    height: 40, // fixed height
                    display: "flex",
                    alignItems: "center"
                }}
            >
                {book.book}
            </div>
            {/* Main section: Image and Button */}
            <div
                style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "16px 24px"
                }}
            >
                {/* Left: Book Image */}
                <div style={{ flex: "0 0 110px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img
                        src={book.imgUrl}
                        alt={book.book}
                        style={{
                            width: 100,
                            height: 140,
                            objectFit: "cover",
                            borderRadius: 8,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            background: "#f8f8f8"
                        }}
                    />
                </div>
                {/* Right: Usage Button */}
                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <div style={{ marginBottom: 16 }}>
                        {book.tags && book.tags.split(",").map(tag => (
                            <span
                                key={tag.trim()}
                                style={{
                                    display: "inline-block",
                                    background: "#e3f2fd",
                                    color: "#1976d2",
                                    fontSize: 12,
                                    borderRadius: 12,
                                    padding: "2px 10px",
                                    marginRight: 6,
                                    marginBottom: 2
                                }}
                            >
                                {tag.trim()}
                            </span>
                        ))}
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end"
                    }}>
                        <button
                            onClick={() => readBook(book.bookId)}
                            style={{
                                padding: "10px 28px",
                                background: "linear-gradient(90deg, #4f8cff 0%, #6dd5ed 100%)",
                                color: "#fff",
                                border: "none",
                                borderRadius: 24,
                                fontWeight: 600,
                                fontSize: 16,
                                cursor: "pointer",
                                boxShadow: "0 2px 8px rgba(79,140,255,0.10)",
                                transition: "background 0.2s",
                            }}
                        >
                            Usage
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookCard;